import CompPopupBottom from '../../compose/popupBottom.vue';
import { fmoney } from '@/utils/tools.js';
import { showImagePreview } from 'vant';
import CompGoalsUnlockHelp from '@@/project/popup/goalsUnlockHelp.vue';
export default {
  props: ["show", "goalUnlockList", "pro_id", "giveaway_type"],
  emits: ['show'],
  components: {
    CompPopupBottom,
    CompGoalsUnlockHelp
  },
  computed: {
    title() {
      const count = this.goalUnlockList.filter(item => item.status === 200).length;
      if (count > 0) {
        return `已达成${count}个解锁目标`;
      } else {
        return '解锁目标';
      }
    }
  },
  data() {
    return {
      statusMap: {
        "100": "努力中",
        "200": "已达成",
        "300": "未达成"
      },
      conditionsBtnMap: {
        '1': '去购买',
        '2': '去分享',
        '3': '去邀请'
      },
      giveawayTypeMap: {
        1: '每个用户赠送一次',
        2: '每个订单赠送一次',
        3: '每份回报档赠送一次'
      },
      goalList: [],
      showUnlockGoalHelp: false
    };
  },
  methods: {
    taskAction(type, reward_id) {
      switch (String(type)) {
        case "1":
          // 去购买
          this.closePopup();
          this.$parent.$refs['compBottomBtn'].onReward(reward_id);
          break;
        case "2": // 去邀请
        case "3":
          // 去分享
          this.closePopup();
          setTimeout(() => {
            this.$parent.copyShareLink();
          }, 300);
          break;
      }
    },
    // 解锁奖励规则说明
    showHelp() {
      this.showUnlockGoalHelp = true;
    },
    closePopup() {
      this.$emit('update:show', false);
    },
    fNum(num) {
      return fmoney(num, 0);
    },
    // 计算”努力中文案“ 
    getIng(item) {
      if (item.status == 100) {
        const isIng = item.conditions.some(raskItem => {
          return raskItem.type == 1 && raskItem.is_completed == 1;
        });
        return isIng;
      }
      return false;
    },
    showBig(img) {
      showImagePreview([img]);
    }
  }
};